var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"my-modal",staticClass:"modal",attrs:{"size":"xl","hide-footer":"","title":"Welcome to Veeam Live – Cloud Data Best Practices","no-close-on-backdrop":""}},[_c('BizzaboForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }